import React from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../../components/base/Dialog/Dialog';
import { responseLogWithNotification } from '../../../../utils/utils';
import {
  Button, Col, Container, Icons, Row,
} from '../../../../components/base/BootstrapComponents';
import { createBlackWhites, editBlackWhites } from '../../actions';
import notificationDecorator from '../../../Notifications/notificationDecorator';
import { getSubscriptionData } from '../../reducer';
import FieldDTO from '../../../../components/fields/Abstract/FieldDTO';
import TextInputWithLabel from '../../../../components/fields/TextInput/TextInputWithLabel';

export default function BlackWhiteDialog(props) {
  const { handleClose = () => {}, loadData = () => {}, type } = props;
  const { currentBlackWhites } = useSelector(getSubscriptionData);
  const dispatch = useDispatch();
  const { control, getValues } = useForm({
    defaultValues: currentBlackWhites?.type ? currentBlackWhites : { type },
  });

  const handleSave = () => {
    const isUpdate = currentBlackWhites?.id;
    const action = isUpdate ? editBlackWhites : createBlackWhites;
    const data = getValues();
    dispatch(action(data))
      .then(() => {
        handleClose();
        loadData();
        notificationDecorator({
          title: isUpdate ? 'Редактирование ГРЗ' : 'Добавление ГРЗ',
          message: isUpdate ? 'Редактирование ГРЗ прошло успешно' : 'Добавление ГРЗ прошло успешно',
        });
      })
      .catch(responseLogWithNotification);
  };

  return (
    <Dialog
      className={classNames('interval-popup')}
      onClose={handleClose}
      size="sm"
      open
    >
      <DialogTitle
        className="hff-title"
        title={(
          <>
            <div className="hff-title-text f2">{type === 'BLACK' ? 'Черный список' : 'Белый список'}</div>
            <div className="hff-close-wrapper">
              <Icons width={14} height={14} customIcon icon="clear" className="hff-close" onClick={handleClose} />
            </div>
          </>
        )}
      />
      <DialogContent className="hff-content">
        <Container>
          <Row>
            <Col>
              <FieldDTO
                control={control}
                type="text"
                className="mb-2"
                dtoObject={
                  {
                    name: 'lpn',
                    type: String,
                    validators: [],
                    labelKey: 'client.lpn',
                  }
}
                addPlaceholder
                component={TextInputWithLabel}
              />
            </Col>
          </Row>
        </Container>
      </DialogContent>
      <DialogFooter className="hff-footer">
        <Button onClick={handleSave}>Сохранить</Button>
        <Button onClick={handleClose}>Закрыть</Button>
      </DialogFooter>
    </Dialog>
  );
}
